import React from 'react';

import styles from './styles.module.scss';
import {logs} from './data';
import {Button} from '../../../components/Button';

export const Logs = () => {
  return (
    <div className={styles.logs}>
      <div className={styles.content}>
        {logs.map((log) => (
          <div className={styles.log} key={log.id}>
            <div className={styles.left}>
              <div className={styles.version}>v{log.version}</div>
              <div className={styles.date}>{log.date}</div>
            </div>
            <div className={styles.right}>
              {log.img && <div className={styles.img}>{log.img}</div>}
              <div className={styles.list}>
                {log.list.map((item) => (
                  <div className={styles.item} key={item.id}>
                    <div className={styles.title}>{item.title}</div>
                    {item.items && (
                      <div className={styles.items}>
                        {item.items.map((el, i) => (
                          <div className={styles.itemDecor} key={i}>
                            {el}
                          </div>
                        ))}
                      </div>
                    )}
                    {item.texts && (
                      <div className={styles.texts}>
                        {item.texts.map((el, i) => (
                          <div key={i}>{el}</div>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className={styles.button}>
        <Button text="Load More" />
      </div>
    </div>
  );
};
